exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.RetweetButton{display:flex\n}\n.RetweetButton>:first-child{padding:10px;margin:-10px -8px -10px -10px\n}\n.RetweetButton .action-counter{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none\n}\n.RetweetButton .interactive .svg-inline--fa{animation-duration:.6s\n}\n.RetweetButton .interactive:hover .svg-inline--fa,.RetweetButton .interactive.-repeated .svg-inline--fa{color:#0fa00f;color:var(--cGreen, #0fa00f)\n}", ""]);

// exports
